import React from "react";
import "../Common/skeleton.css";
import "./Home.css";

const Bar = ({ width, height = 10, dark = false, style, className = "" }) => (
  <div
    className={`sk ${dark ? "sk--dark" : ""} ${className}`}
    style={{ width, height, ...style }}
  />
);

export const UpdatesSkeleton = ({ count = 4 }) =>
  Array.from({ length: count }, (_, key) => (
    <div className="hm-update" key={key} aria-hidden="true">
      <div className="hm-update-head">
        <Bar width={26} height={26} style={{ flex: "0 0 26px", borderRadius: 7 }} />
        <div style={{ flex: 1, paddingTop: 4 }}>
          <Bar width={key % 2 ? "62%" : "74%"} height={13} />
        </div>
        <Bar width={52} height={10} style={{ marginTop: 6 }} />
      </div>
      <div className="hm-update-desc">
        <Bar width="96%" />
        <Bar width="82%" style={{ marginTop: 8 }} />
      </div>
      <div className="hm-update-foot">
        <Bar width={72} />
        <Bar width={88} />
      </div>
    </div>
  ));

export const InsightsSkeleton = ({ count = 4 }) =>
  Array.from({ length: count }, (_, key) => (
    <div className="hm-insight" key={key} aria-hidden="true">
      <Bar width="100%" height={104} style={{ borderRadius: 10 }} />
      <div style={{ minWidth: 0, paddingTop: 2 }}>
        <Bar width={84} />
        <Bar width={key % 2 ? "70%" : "84%"} height={13} style={{ marginTop: 10 }} />
        <Bar width="95%" style={{ marginTop: 12 }} />
        <Bar width="78%" style={{ marginTop: 8 }} />
        <Bar width={76} style={{ marginTop: 14 }} />
      </div>
    </div>
  ));

const BriefSkeleton = ({ dark = false }) => (
  <div className={`hm-brief ${dark ? "hm-brief--tone" : ""}`} aria-hidden="true">
    <div className="hm-brief-head">
      <div style={{ flex: 1 }}>
        <Bar width={96} dark={dark} />
        <Bar width="72%" height={22} dark={dark} style={{ marginTop: 14 }} />
      </div>
      <Bar width={40} height={40} dark={dark} style={{ borderRadius: 10, flex: "0 0 40px" }} />
    </div>
    <Bar width="88%" dark={dark} style={{ marginTop: 16 }} />
    <Bar width="64%" dark={dark} style={{ marginTop: 8 }} />
    <div style={{ marginTop: "auto", paddingTop: 20 }}>
      {dark ? (
        <>
          <Bar width="100%" height={5} dark style={{ borderRadius: 999 }} />
          <div className="d-flex justify-content-between" style={{ marginTop: 14 }}>
            <Bar width={48} dark />
            <Bar width={96} dark />
            <Bar width={48} dark />
          </div>
        </>
      ) : (
        <Bar width={112} height={12} />
      )}
    </div>
  </div>
);

const PanelSkeleton = ({ children, withLink = false }) => (
  <div className="hm-card hm-panel">
    <div className="hm-panel-head">
      <Bar width={132} height={14} />
      {withLink && <Bar width={64} />}
    </div>
    {children}
  </div>
);

// Full-page placeholder for Home while auth/subscriptions resolve. Uses the
// real Home layout classes so the page does not jump when it mounts.
const HomeSkeleton = () => (
  <div className="hm-page" aria-busy="true" aria-label="Loading home">
    <div className="hm-shell">
      <header>
        <Bar width={280} height={30} />
        <Bar width={200} height={14} style={{ marginTop: 12 }} />
      </header>

      <section className="hm-card hm-ask">
        <Bar width={190} height={13} />
        <Bar width="100%" height={48} style={{ marginTop: 14, borderRadius: 12 }} />
        <div className="d-flex gap-2" style={{ marginTop: 12 }}>
          {[180, 220, 160].map((width) => (
            <Bar key={width} width={width} height={28} style={{ borderRadius: 999 }} />
          ))}
        </div>
      </section>

      <section className="hm-brief-grid">
        <BriefSkeleton dark />
        <BriefSkeleton />
        <BriefSkeleton />
      </section>

      <section className="hm-panels">
        <PanelSkeleton>
          <div className="hm-panel-body hm-panel-body--cards" style={{ overflow: "hidden" }}>
            <UpdatesSkeleton />
          </div>
        </PanelSkeleton>
        <PanelSkeleton withLink>
          <div className="hm-panel-body" style={{ overflow: "hidden" }}>
            <InsightsSkeleton />
          </div>
        </PanelSkeleton>
      </section>
    </div>
  </div>
);

export default HomeSkeleton;
